<template>
  <el-row
    :gutter="schema.gutter | nil(0)"
    :type="schema.type | nil('')"
    :justify="schema.justify | nil('start')"
    :align="schema.align | nil('')"
    :tag="schema.tag | nil('div')"
  >
    <fragment
      :key="`${schema.id}_${index}`"
      v-for="(item, index) in schema.items"
    >
      <component
        :is="item.xType"
        :schema="{ ...item, ...$options.filters._frm_data(schema.formData) }"
        :path="`${path}.items[${index}]`"
        @update:schema="
          (sval, stype, spath) => {
            $emit('update:schema', sval, stype, spath);
          }
        "
      >
      </component>
    </fragment>
  </el-row>
</template>
<script>
export default {
  name: "QRow",
  props: {
    schema: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
};
</script>
